import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { IApiPagination } from "../../../interfaces/IPagination";
import {
  CategoryInterface,
  GetCategoriesResponse,
  TCategoryFilter,
} from "../../../interfaces/categoryInterface";
import axiosTeethTab from "../../../services/apiCall";

type CategoryApiInterface = {
  getCategories: (
    filter: TCategoryFilter,
    pagination: IApiPagination,
  ) => Promise<ApiResponse<GetCategoriesResponse>>;
  saveCategory: (
    category: CategoryInterface,
  ) => Promise<ApiResponse<CategoryInterface>>;
  getCategoryById: (id: string) => Promise<ApiResponse<CategoryInterface>>;
  enable: (id: string) => Promise<ApiResponse<CategoryInterface>>;
  disable: (id: string) => Promise<ApiResponse<CategoryInterface>>;
};

export const categoryApi: CategoryApiInterface = {
  getCategories: async (filter, pagination) => {
    return await axiosTeethTab.get("categories/filter", {
      params: { filter, pagination },
    });
  },
  saveCategory: async (category) => {
    const endpoint = category._id
      ? `categories/${category._id}`
      : "categories";
    return await axiosTeethTab.post<CategoryInterface>(endpoint, category);
  },
  getCategoryById: async (id: string) => {
    return await axiosTeethTab.get<CategoryInterface>(`categories/${id}`);
  },
  enable: async (id: string) => {
    return await axiosTeethTab.patch<CategoryInterface>(`categories/${id}/enable`);
  },
  disable: async (id: string) => {
    return await axiosTeethTab.patch<CategoryInterface>(`categories/${id}/disable`);
  },
};
